export enum ECurrency {
  EUR = 'EUR',
  USD = 'USD',
  PLN = 'PLN',
  GBP = 'GBP',
}

export const CURRENCY_LABELS: Record<ECurrency, string> = {
  [ECurrency.EUR]: 'EUR',
  [ECurrency.USD]: 'USD',
  [ECurrency.PLN]: 'PLN',
  [ECurrency.GBP]: 'GBP',
};

export const CURRENCY_SIGN: Record<ECurrency, string> = {
  [ECurrency.EUR]: '€',
  [ECurrency.USD]: '$',
  [ECurrency.PLN]: 'zł',
  [ECurrency.GBP]: '£',
};

type TCurrencyOption = {
  value: ECurrency;
  label: string;
};

export const CURRENCIES: TCurrencyOption[] = [
  { value: ECurrency.EUR, label: CURRENCY_SIGN[ECurrency.EUR] },
  { value: ECurrency.USD, label: CURRENCY_SIGN[ECurrency.USD] },
  { value: ECurrency.PLN, label: CURRENCY_SIGN[ECurrency.PLN] },
  { value: ECurrency.GBP, label: CURRENCY_SIGN[ECurrency.GBP] },
];
